var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

var $ = require("./lib/qsa");

var { svg, render } = require("lit-html");

const SANKEY_MARGIN = 30;
const SANKEY_WEIGHT = 5;
const LABEL_SIZE = 15;

// console.clear();

function generateSankey(host, data) {
  // clone this so we can mutate it freely
  data = structuredClone(data);

  var { connections, nodes } = data;

  for (var connection of connections) {
    // build node structures
    var [ from, to, size ] = connection;
    for (var key of [from, to]) {
      // handle shorthand nodes
      if (typeof nodes[key] == "string" || !(key in nodes)) {
        nodes[key] = { label: nodes[key] };
      }
      var node = nodes[key];
      node.id = key;
      if (!("width" in node)) {
        node.width = 0;
        node.dynamic = true;
      }
      if (node.dynamic) {
        node.width += size;
      }
    }
  }

  var lines = [
    { position: "start", keys: new Set(connections.map(c => c[0])) },
    { position: "end", keys: new Set(connections.map(c => c[1])) }
  ];

  // aggregate widths, other housekeeping
  for (var line of lines) {
    line.total = 0;
    line.nodes = [];
    for (var k of line.keys.values()) {
      var node = nodes[k];
      line.total += node.width;
      line.nodes.push(node);
    }
  }
  
  // you can set a manual width, but otherwise generate it with some spacing
  if (!data.width) {
    var max = Math.max(...lines.map(l => l.total));
    max *= 1.5;
    data.width = 2200;max;
  }

  // canvas size
  var bounds = host.getBoundingClientRect();
  // universal scaler
  var scaler = x => Math.max((x / data.width * bounds.width) | 0, 2);
  // track start positions of each endpoint
  var offsets = new Map();

  // created rendered line segments
  var endpoints = lines.map(function(line, i) {
    // segments are effectively display: flex with justify-content: space-between
    // so find the free space and divide it between segments
    var free = data.width - line.total;
    var spacing = free / (line.nodes.length + 1);
    var left = 0;
    var lineY = i ? bounds.height - SANKEY_MARGIN : SANKEY_MARGIN;
    var textY = i ? lineY + SANKEY_WEIGHT / 2 + LABEL_SIZE + 2 : lineY - SANKEY_WEIGHT / 2 - 4;
    // for each node, create a line segment
    return line.nodes.map(function(node) {
      var {
        offsetY = 0,
        color = "black"
      } = node;
      offsetY = Number(offsetY);
      var l = left + spacing;
      var x1 = scaler(l);
      var x2 = x1 + scaler(node.width);
      var center = scaler(l + node.width / 2);
      left += node.width + spacing;
      offsets.set(node, l);
      // TODO: support little arrow annotations instead of labels
      // that's useful for little slivers
      return svg`<g data-node=${node.id} color=${color}>
      <line
        class="segment-cap"
        x1=${x1}
        x2=${x2}
        y1=${lineY + offsetY} y2=${lineY + offsetY}
        stroke="currentColor"
        stroke-width=${SANKEY_WEIGHT}
      />
      <text
        class="segment-label ${node.id}"
        x=${center}
        y=${textY + offsetY}
        font-size=${LABEL_SIZE}
        fill="currentColor"
      >${node.label}</text>
     </g>`;
    });
  });

  // create rendered connection paths
  var flows = connections.map(function(connection) {
    var [ from, to, size ] = connection;
    var startNode = nodes[from];
    var endNode = nodes[to];
    var {
      color = "black",
      offsetY = 0
    } = endNode;
    // get the current offset for each node
    var start = offsets.get(startNode);
    var end = offsets.get(endNode);
    // update offset for the next path to/from these nodes
    offsets.set(startNode, start + size);
    offsets.set(endNode, end + size);
    var startY = SANKEY_MARGIN + SANKEY_WEIGHT / 2 + 2 | 0;
    var endY = bounds.height - SANKEY_WEIGHT / 2 - SANKEY_MARGIN - 2;
    var yScale = t => (startY + (endY - startY) * t) | 0;
    endY += Number(offsetY);
    var left = [start, (start + end) / 2, end].map(scaler);
    var right = left.map(n => n + scaler(size) - 1).reverse();
    var pathString = [
      // upper left line
      `M${left[0]},${yScale(0)}`,
      // curve in to the line's midpoint
      `Q${left[0]},${yScale(.2)},${left[1]},${yScale(.5)}`,
      // mirrored curve out to the other side
      `T${left[2]},${yScale(1)}`,
      // bottom of the path
      `L${right[0]},${endY | 0}`,
      // curve back up
      `Q${right[0]},${yScale(.8)},${right[1]},${yScale(.5)}`,
      `T${right[2]},${startY | 0}`,
      `Z`
    ].join(" ");
    return svg`<path
      class="connection"
      data-from=${from} data-to=${to}
      d=${pathString}
      fill=${color}
      opacity=".4" />`
  });

  render(svg`
    <g class="top segments"> ${endpoints[0]} </g>
    <g class="flow paths"> ${flows} </g>
    <g class="bottom segments"> ${endpoints[1]} </g>
  `, host);
}

var svgs = $("svg");
function draw() {
  for (var svg of svgs) {
    var id = svg.id;
    var data = window.DATA[id];
    generateSankey(svg, data);
  }
}
draw();
window.addEventListener("resize", draw);